import React, { Component } from 'react';
import api from "../../services/api";
import { getToken } from "../../services/auth";

class FormUserLog extends Component {
  state = {
    url: 'usuario/log/' + this.props.user.id_usuario,
    logs: [],
    showStore: true,
  }

  getLogs(token) {
    api.get(this.state.url, { headers: { token } })
        .then(response => {
            this.setState({
              logs: this.state.logs.length > 0 ? 
              this.state.logs.concat(response.data.data) : response.data.data,
              url: response.data.next_page_url
            })
            this.makePagination(response.data)
        }).catch(err => console.log(err));
  }

  makePagination(data) {
    let pagination = {
        current_page: data.current_page,
        last_page: data.last_page,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,

    }

    this.setState({
        pagination: pagination
    })
}

loadMore() {
    if (this.state.pagination.current_page !== this.state.pagination.last_page) {
        this.setState({
            url: this.state.pagination.next_page_url
        })
        this.getLogs(getToken())
    } else {
        this.setState({ showStore: false });
    }
}

  componentDidMount() {
    this.getLogs(getToken())
  }

  render() {

    const logs = this.state.logs.map(log => {
      return (
        <tr key={log.id}>
          <td>{log.ultimo_login}</td>
          <td>{log.id_modulo}</td>
          <td>{log.ip}</td>
          <td>{log.dispositivo}</td>
          <td>?</td>
        </tr>
      )
  })

    return (
      <>
        <div className="pt-3 log-usuario-wrapper">
          <header >
            Log de Usuário
          </header>
          <div className="log-wrapper is-overflow">
            <header >
              Tabela de Log
          </header>
            <div className="tabela-wrapper">
              <div className="table-responsive">
                <table className="table table-bordered" id="table-log">
                  <thead>
                    <tr>
                      <th>Data do Log</th>
                      <th>Última Ação</th>
                      <th>Ip</th>
                      <th>Navegador</th>
                      <th>Tempo Ativo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs}
                  </tbody>
                </table>
              <button style={{ display: this.state.showStore ? 'block' : 'none' }}
                className="btn btn-dommus-action" onClick={this.loadMore.bind(this, 'next')}>
                Carregue mais paginação
              </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default FormUserLog